<div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto mb-5 contract-management-module">
  <div style="padding-left: 15px" class="col-12 no-gutters">
    <app-layout-header [isContractManagementModule]="true" class="col-12 no-gutters"></app-layout-header>
  </div>
  <div class="col-12 no-gutters row">
    <img class="img-fluid w-100 h-100 contract-management-banner" src="assets/images/contract-management-banner.png"
      alt="" />
  </div>
  <div class="mt-3 col-12">
    <div class="box-title-module clearfix">
      <span class="module-name mr-2 float-left">Contract Management</span>
      <div class="float-right">
        <!-- TODO remove after migration -->
        <!-- <a class="btn mr-1" (click)="fileInput.click()">
          Migrate
        </a>
        <input #fileInput hidden type="file"
          (click)="$event.target.value = ''"
          (change)="migrateContracts($event.target.files[0])" > -->
        <!-- TODO -->
        <a class="btn mr-1" [routerLink]="['/', PATH_ROUTING.PATH_CONTRACT]" [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }">
          Home
        </a>
        <!-- TODO on hold until clear requirement -->
        <!-- <a *ngIf="!isLoginUserViewer()" class="btn"
          [ngClass]="{ 'mr-1': !isInCreateScreen && !isLoginUserViewer() }"
          [routerLink]="['/', PATH_ROUTING.PATH_CONTRACT, PATH_ROUTING.PATH_CONTRACT_DELEGATE]"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }">
          Delegate
        </a> -->
        <!-- TODO -->
        <ng-container *ngIf="!isInCreateScreen">
          <a *ngIf="!isLoginUserViewer()" class="btn"
            [routerLink]="['/', PATH_ROUTING.PATH_CONTRACT, PATH_ROUTING.PATH_CREATE_CONTRACT]"
            [routerLinkActive]="'active'">
            Create Contract
          </a>
        </ng-container>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer-layout></app-footer-layout>